<template>
  <div class="team-dialog">
    <el-dialog title="基础信息" :visible="true" width="60%" :show-close="false">
      <div class="content">
        <div class="basis">
          <div class="row">
            <span>战队名称：</span>
            <div class="control">
              <el-input
                :maxlength="8"
                size="small"
                type="text"
                v-model="name"
                :disabled="isDissolve || allDisabled"
                placeholder="请输入战队名称"
              ></el-input>
            </div>
          </div>

          <div class="row" v-if="this.openType === 'editor'">
            <span>修改段位：</span>
            <div class="control">
              <el-select size="small" v-model="grade" placeholder="请选择">
                <el-option
                  v-for="item in danOptionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="isDissolve"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="players">
          <div class="title">添加队员</div>

          <div class="row">
            <span>请输入员工薪人薪事手机号：</span>
            <div class="control">
              <el-input
                maxlength="11"
                type="text"
                size="small"
                v-model="phone"
                placeholder="请输入1开头的手机号"
              >
              </el-input>
            </div>
            <el-button
              size="small"
              type="primary"
              @click="handleAddMembers"
              :loading="addButLoading"
              :disabled="isDissolve || allDisabled"
            >
              添加
            </el-button>
          </div>

          <div class="table">
            <el-table
              :data="membersList"
              style="width: 100%"
              :border="true"
              row-key="saleId"
            >
              <el-table-column
                v-for="item in tableColumn"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
                align="center"
                :min-width="item.width || '100'"
              >
              </el-table-column>
              <el-table-column
                key="isLeader"
                prop="isLeader"
                label="设为队长"
                align="center"
                min-width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="isDissolve || allDisabled"
                    :value="scope.row.isLeader"
                    @change="handleLeaderChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                key="option"
                prop="option"
                label="操作"
                align="center"
                min-width="80"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :disabled="isDissolve || allDisabled"
                    @click="handleRemove(scope.row)"
                  >
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="footer">
        <el-button size="small" @click="handleClose(0)">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleSave"
          :disabled="isDissolve"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { danList, playersColumn, translationDan } from "./assets";
import * as API from "@/api/season";

export default {
  props: ["defaultData", "handleClose", "openType"],
  data() {
    const { name, grade, type, status } = this.defaultData;
    return {
      tableColumn: playersColumn,
      danOptionList: danList,
      name,
      phone: null,
      membersListSource: [],
      membersList: [],
      grade,
      addButLoading: false,
      allDisabled: type === 1,
      isDissolve: status === 2,
    };
  },
  watch: {
    phone: function (next, prev) {
      if (this.phone?.[0] != 1) {
        this.phone = null;
        return;
      }
      this.phone = this.phone.replace(/[^\d]/g, "");
    },
  },
  created() {
    this.openType === "editor" && this.getTeamOfMembers();
  },
  methods: {
    async getTeamOfMembers() {
      const { id, captainId } = this.defaultData;
      try {
        const params = {
          seasonTeamId: id,
        };
        const res = await API.getTeamOfMembers(params);
        const { code, data } = res;
        if (code === 0) {
          const nextData = data.map((item) => {
            return {
              ...item,
              isLeader:
                captainId && item.saleId ? item.saleId === captainId : false,
            };
          });
          this.membersListSource = nextData;
          this.membersList = nextData;
        }
      } catch (error) {
        //防止request返回reject
      }
    },
    async handleAddMembers() {
      const { phone, membersList } = this;
      //最多五人
      if (membersList.length >= 5) {
        this.$confirm("最多添加5个队员", {
          confirmButtonText: "确定",
          showCancelButton: false,
        });
        return;
      }
      //手机号正确
      if (!phone || phone?.length !== 11) {
        this.$message.warning("请输入正确的手机号！");
        return;
      }
      //队伍中存在
      let hasCurrent = false;
      for (const members of membersList) {
        if (members.mobile === phone) {
          hasCurrent = true;
          break;
        }
      }
      if (hasCurrent) {
        this.$message.warning("队伍中已存在该队员");
        return;
      }
      //人员不在其他队伍
      let noHasOther = false;
      await new Promise((resolve) => {
        this.memberIsInOtherTeam([phone], resolve);
      }).then((res) => {
        if (res.length < 1) {
          noHasOther = true;
        } else {
          this.$message.warning(`此员工已存在于其他战队`);
        }
      });
      if (!noHasOther) return;
      //添加
      this.addButLoading = true;
      const params = {
        phone,
      };
      try {
        const res = await API.getTeamMembersInfo(params);
        const { code, data } = res;
        if (code === 0 && data) {
          if (data[0]) {
            const { userId, nickName, belongCompanyName } = data[0];
            this.membersList.push({
              ...data[0],
              saleId: userId,
              saleName: nickName,
              companyName: belongCompanyName,
              isLeader: false,
            });
          } else {
            this.$message.warning("未查询到此号码的员工信息");
          }
        }
      } catch (error) {
        //防止request返回reject
      } finally {
        this.addButLoading = false;
      }
    },
    handleLeaderChange(rowData) {
      this.membersList = this.membersList.map((item) => ({
        ...item,
        isLeader: item.saleId === rowData.saleId,
      }));
    },
    handleRemove(rowData) {
      this.membersList = this.membersList.filter(
        (item) => item.saleId !== rowData.saleId
      );
    },
    async memberIsInOtherTeam(phoneList, callback) {
      const phoneListP = phoneList.map((item) => {
        return function () {
          return {
            phone: item,
            action: API.personIsInOtherTeam({ phone: item }),
          };
        };
      });
      let isInList = [];
      for (const P of phoneListP) {
        const { action, phone } = P();
        try {
          const res = await action;
          const { code, data } = res;
          if (code === 0) {
            switch (data) {
              case 0:
                break;
              default:
                isInList.push(phone);
                break;
            }
          } else {
            throw Error();
          }
        } catch (error) {
          isInList.push(phone);
          continue;
        }
      }
      callback(isInList);
    },
    async handleSave() {
      const {
        name,
        membersList,
        grade,
        membersListSource,
        openType,
        defaultData,
      } = this;
      //表单必填项
      if (!name) {
        this.$message.warning("战队名称不能为空");
        return;
      }
      if (membersList.length !== 5) {
        this.$message.warning("战队人数必须为五人");
        return;
      }
      //有无队长
      let hasLeader = false;
      for (const val of membersList) {
        if (val.isLeader) {
          hasLeader = true;
          break;
        }
      }
      if (!hasLeader) {
        this.$confirm("请设置队长后再保存！！！", {
          confirmButtonText: "确定",
          showCancelButton: false,
        });
        return;
      }
      //人员均无战队
      let noHasOther = false;
      await new Promise((resolve) => {
        const mobileList = membersList
          .map((item) => !item.id && item.mobile)
          .filter(Boolean);
        this.memberIsInOtherTeam(mobileList, resolve);
      }).then((res) => {
        if (res.length < 1) {
          noHasOther = true;
        } else {
          this.$message.warning(`以下手机号已存在于别的战队 ${res.toString()}`);
        }
      });
      if (!noHasOther) return;
      //用户已确认保存
      let nextFlag = false;
      await new Promise((resolve) => {
        if (openType === "add") {
          this.$confirm("请确认好信息无误，战队人员一旦确定，无法修改", {
            confirmButtonText: "没问题直接保存",
            cancelButtonText: "我再去检查一遍",
          })
            .then(() => {
              nextFlag = true;
              resolve();
            })
            .catch(() => {
              //不做处理，用户停止保存
            });
        } else if (openType === "editor" && defaultData.type === 2) {
          let changeNum = 0;
          membersListSource.forEach((item) => {
            const { saleId } = item;
            const sourceHas = membersList.find((ele) => ele.saleId === saleId);
            if (!sourceHas) changeNum++;
          });
          const nextGrade =
            changeNum === 0
              ? translationDan(grade)
              : changeNum >= 3
              ? "青铜"
              : translationDan(grade - 2 < 1 ? 1 : grade - 2);
          const confirmMessage =
            defaultData.grade !== grade
              ? `您已直接修改该战队段位，将变为${translationDan(grade)}段位`
              : `您当前更换了${changeNum}个队员，将变为${nextGrade}段位，在下个赛季开始前，您只有这一次更换机会，请仔细确认更换信息`;
          this.$confirm(confirmMessage, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(() => {
              nextFlag = true;
              resolve();
            })
            .catch(() => {
              //不做处理，用户停止保存
            });
        } else {
          nextFlag = true;
        }
      });
      if (!nextFlag) return;
      //最后请求
      try {
        let captainId, captainName;
        const list = membersList.map((item) => {
          const { saleId, isLeader, saleName } = item;
          if (isLeader) {
            captainId = saleId;
            captainName = saleName;
          }
          return {
            ...item,
            isLeader: undefined,
          };
        });
        const params = {
          grade,
          id: defaultData.id,
          list,
          name,
          captainId,
          captainName,
        };
        const res =
          openType === "add"
            ? await API.addTeam(params)
            : await API.updateTeam(params);
        const { code } = res;
        if (code === 0) {
          this.$message.success("保存成功");
          this.handleClose(openType === "add" ? 1 : 2);
        }
      } catch (error) {
        //防止request返回reject
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.team-dialog {
  .content {
    .basis {
      .row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
    }
    .players {
      margin-bottom: 20px;
      > .title {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
        margin-bottom: 50px;
      }
      .row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .control {
          margin-right: 20px;
        }
      }
    }
  }
  .footer {
    text-align: right;
  }
}
</style>
